/* Helee product cards: adds a footer with a real stock badge (from the product's live availability) and moves the quick add to cart icon into it. */
(function(){
  var cache = {};
  function availability(handle){
    if (cache[handle]) return cache[handle];
    var key = 'hlav:' + handle;
    try { var v = sessionStorage.getItem(key); if (v !== null) return cache[handle] = Promise.resolve(v === '1'); } catch(e) {}
    return cache[handle] = fetch('/products/' + handle + '.js', {credentials: 'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ if (!p) return null; var a = !!p.available; try { sessionStorage.setItem(key, a ? '1' : '0'); } catch(e) {} return a; })
      .catch(function(){ return null; });
  }
  function enhance(card){
    if (card.getAttribute('data-hl-done')) return;
    card.setAttribute('data-hl-done', '1');
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
    var foot = document.createElement('div');
    foot.className = 'hl-pc-foot';
    var badge = document.createElement('span');
    badge.className = 'hl-pc-stock';
    badge.hidden = true;
    foot.appendChild(badge);
    var btns = card.querySelector('.product-card__additional-buttons');
    if (btns) foot.appendChild(btns);
    (card.querySelector('.product-card__footer') || card).appendChild(foot);
    availability(handle).then(function(a){
      if (a === null) return;
      badge.textContent = a ? 'På lager' : 'Udsolgt';
      if (!a) badge.className += ' is-out';
      badge.hidden = false;
    });
  }
  function run(root){ (root || document).querySelectorAll('.product-card-new').forEach(enhance); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
  new MutationObserver(function(list){
    list.forEach(function(m){ m.addedNodes.forEach(function(n){
      if (n.nodeType !== 1) return;
      if (n.matches && n.matches('.product-card-new')) enhance(n); else if (n.querySelectorAll) run(n);
    }); });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();